<template>
  <div>
    <TableFilters
      :filters="[
        'customer',
        'biller',
        'dateRange',
        'shop',
        'saleType',
        'product',
      ]"
      v-model="filter"
      @updateColumnsTable="updateColumnsTable"
      :columns="columns"
      :export="[`salesexport`]"
    ></TableFilters>
    <v-row v-if="errormsg">
      <v-col>
        <span style="color: red"> * Shop Cant be Empty</span>
      </v-col>
    </v-row>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="pdfdownload()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="salesList"
              item-key="name"
              class="row-pointer"
              id="indextable10"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <!-- <img
                      style="height: 200px"
                      src="../../../assets/img/no-result.jpg"
                    /> -->
                </div>
              </template>
              <template v-slot:item.reference_number="{ item }">
                <CopyTableCell :text="item.reference_number"></CopyTableCell>
              </template>

              <template v-slot:item.date="{ item }">
                {{ item.date | formatDate }}
              </template>

              <template v-slot:item.biller="{ item }">
                {{ item.biller.first_name }}
              </template>
              <template v-slot:item.customer="{ item }" v-slot="{ errors }">{{
                item.customer.name
              }}</template>
              <template
                slot="body.append"
                v-if="salesList && salesList.length > 0"
              >
                <tr class="black--text">
                  <th class="title"></th>
                  <th class="title"></th>
                  <!-- <th class="title"></th> -->
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th class="title"></th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ grandTotal | formatCurrency }}
                    </h3>
                  </th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ discountTotal | formatCurrency }}
                    </h3>
                  </th>
                  <th>
                    <h3 class="justify-content-end pl-2">
                      {{ total | formatCurrency }}
                    </h3>
                  </th>

                  <th class="title"></th>
                  <!-- <th class="title"></th> -->
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
    <!-- </v-card> -->
    <div class="d-flex justify-center align-center"></div>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import confirmation from '../shared/components/confirmation';
import { mapState } from 'vuex';

export default {
  components: {
    TableFilters,
  },
  data() {
    return {
      hide: '',
      isLoading: true,
      errormsg: false,
      total: 0,
      grandTotal: 0,
      discountTotal: 0,
      columns: [
        {
          text: 'No',
          value: 'no',
          show: true,
          disabled: false,
          width: '14%',
          render: (item) => item?.no,
        },
        {
          text: 'Date',
          value: 'date',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => moment(item.date).format('YYYY-MM-DD'),
        },
        {
          text: 'Reference Number',
          value: 'reference_number',
          show: true,
          disabled: false,
          width: '14.2%',
          render: (item) => item?.reference_number,
        },
        {
          text: 'Type',
          value: 'sale_type',
          show: true,
          disabled: false,
          align: 'center',
          width: '8%',
          render: (item) => item?.sale_type,
        },
        {
          text: 'Biller',
          value: 'biller',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.biller.first_name,
        },
        {
          text: 'Customer',
          value: 'customer',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.customer.name,
        },
        {
          text: 'Total Items',
          value: 'total_items',
          show: true,
          disabled: false,
          align: 'center',
          width: '14.2%',
          render: (item) => item?.total_items,
        },
        {
          text: 'Total Amount',
          value: 'total',
          show: true,
          disabled: false,
          align: 'right',
          width: '13%',
          render: (item) => item?.total,
        },
        {
          text: 'Discount Amount',
          value: 'discount_amount',
          show: true,
          disabled: false,
          align: 'right',
          width: '13.5%',
          render: (item) => item?.discount_amount,
        },
        {
          text: 'Net Amount',
          value: 'grand_total',
          show: true,
          disabled: false,
          align: 'right',
          width: '12%',
          render: (item) => item?.grand_total,
        },
      ],
      salesList: [],
      shoperror: '',
      filter: {
        customer: '',
        biller: '',
        start: '',
        end: '',
        shop: '',
        saleType: '',
        product: '',
      },
    };
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },
    generateReport(callBack = () => {}) {
      if (this.filter.shop) {
        this.errormsg = false;
        var filter = this.filter;
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

        this.$store
          .dispatch('report/getSalesReports', filter)
          .then((res) => {
            this.salesList = res.data.data;
            this.total = this.sumField(this.salesList, 'grand_total');
            this.grandTotal = this.sumField(this.salesList, 'total');
            this.discountTotal = this.sumField(
              this.salesList,
              'discount_amount',
            );
            let i = 1;
            this.salesList.map((p) => {
              p.no = i;
              i++;
            });
            let saleAmount = {
              total: this.total,
              grandTotal: this.grandTotal,
              discountTotal: this.discountTotal,
            };
            setTimeout(() => {
              callBack();
              // Update Pdf To List
              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.salesList);
              // Update Pdf To List_Title
              this.$store.commit('UPDATE_PDF_TITLE', 'Sales');
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
              this.$store.commit('UPDATE_SALE_TOTAL', saleAmount);
            }, 100);
          })
          .catch((err) => {
            this.shoperror = err.data;
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PDF_VISIBLE', false);

            this.isLoading = false;
            this.messages = err.data.title;
          });
      } else {
        this.$confirm('Please Select the Shop then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.salesList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 1000);
    },

    //Product Details Export Pdf
    async pdfdownload() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.salesList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date = moment(Data[x].date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );
          Data[x].customer = Data[x].customer.name;
          Data[x].biller = Data[x].biller.first_name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(14);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Sales Report', 15, 6);

        doc.setFontSize(8);
        doc.text(
          230,
          6,
          `Generated Date & Time :-${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
        );
        doc.text(247, 11, `Total Amount :- ${this.total.toFixed(2)}`);
        doc.text(247, 16, `Grand Total :- ${this.grandTotal.toFixed(2)}`);
        doc.text(247, 21, `Discount Total :- ${this.discountTotal.toFixed(2)}`);

        // let height;
        // if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.customerquery == "" ||
        //     this.filterDatas.customerquery == null) &&
        //   (this.filterDatas.productquery == "" ||
        //     this.filterDatas.productquery == null) &&
        //   (this.filterDatas.shop == "" || this.filterDatas.shop == null)
        // ) {
        //   height = 25;
        // } else if (
        //   (this.filterDatas.customerquery == "" ||
        //     this.filterDatas.customerquery == null) &&
        //   (this.filterDatas.productquery == "" ||
        //     this.filterDatas.productquery == null) &&
        //   (this.filterDatas.shop == "" || this.filterDatas.shop == null)
        // ) {
        //   this.filterDatas.start && this.filterDatas.end
        //     ? doc.text(
        //         `Date Range              -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   height = 25;
        // } else if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.customerquery == "" ||
        //     this.filterDatas.customerquery == null) &&
        //   (this.filterDatas.shop == "" || this.filterDatas.shop == null)
        // ) {
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product               -     ${this.filterDatas.productquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   height = 25;
        // } else if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.productquery == "" ||
        //     this.filterDatas.productquery == null) &&
        //   (this.filterDatas.shop == "" || this.filterDatas.shop == null)
        // ) {
        //   this.filterDatas.customerquery
        //     ? doc.text(
        //         `Customer               -     ${this.filterDatas.customerquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   height = 25;
        // } else if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.productquery == "" ||
        //     this.filterDatas.productquery == null) &&
        //   (this.filterDatas.customerquery == "" ||
        //     this.filterDatas.customerquery == null)
        // ) {
        //   this.filterDatas.shop
        //     ? doc.text(`Shop      -     ${this.filterDatas.shop}`, 15, 12)
        //     : null;
        //   height = 25;
        // } else if (
        //   (this.filterDatas.start == "" || this.filterDatas.start == null) &&
        //   (this.filterDatas.end == "" || this.filterDatas.end == null) &&
        //   (this.filterDatas.productquery == "" ||
        //     this.filterDatas.productquery == null) &&
        //   (this.filterDatas.shop == "" || this.filterDatas.shop == null)
        // ) {
        //   this.filterDatas.start && this.filterDatas.end
        //     ? doc.text(
        //         `Date Range              -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   height = 25;
        // } else if (
        //   (this.filterDatas.shop == "" || this.filterDatas.shop == null) &&
        //   (this.filterDatas.customerquery == "" ||
        //     this.filterDatas.customerquery == null)
        // ) {
        //   this.filterDatas.start && this.filterDatas.end
        //     ? doc.text(
        //         `Date Range              -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product                    -     ${this.filterDatas.productquery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   height = 25;
        // } else if (
        //   this.filterDatas.shop == "" ||
        //   this.filterDatas.shop == null
        // ) {
        //   this.filterDatas.start && this.filterDatas.end
        //     ? doc.text(
        //         `Date Range              -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product                   -     ${this.filterDatas.productquery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   this.filterDatas.customerquery
        //     ? doc.text(
        //         `Customer               -     ${this.filterDatas.customerquery}`,
        //         15,
        //         22
        //       )
        //     : null;
        //   height = 25;
        // } else if (
        //   (this.filterDatas.productquery == "" ||
        //     this.filterDatas.productquery == null) &&
        //   (this.filterDatas.shop == "" || this.filterDatas.shop == null)
        // ) {
        //   this.filterDatas.start && this.filterDatas.end
        //     ? doc.text(
        //         `Date Range              -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product                    -     ${this.filterDatas.productquery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   this.filterDatas.customerquery
        //     ? doc.text(
        //         `Customer               -     ${this.filterDatas.customerquery}`,
        //         15,
        //         22
        //       )
        //     : null;
        //   height = 25;
        // } else {
        //   height = 30;
        //   this.filterDatas.start && this.filterDatas.end
        //     ? doc.text(
        //         `Date Range              -     ${this.filterDatas.start}  -  ${this.filterDatas.end}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.productquery
        //     ? doc.text(
        //         `Product                    -     ${this.filterDatas.productquery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //   this.filterDatas.customerquery
        //     ? doc.text(
        //         `Customer               -     ${this.filterDatas.customerquery}`,
        //         15,
        //         22
        //       )
        //     : null;
        //   this.filterDatas.shop
        //     ? doc.text(`Shop     -     ${this.filterDatas.shop}`, 15, 27)
        //     : null;
        // }

        const conditions = [
          { key: 'customerquery', label: 'Customer' },
          { key: 'shopquery', label: 'Shop' },
          { key: 'productquery', label: 'Product' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(
            condition.key,
            condition.label,
            value,
            condition.offset,
          );

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5;
          }

          return acc;
        }, 12); // Initial offset

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment offset
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Sales.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable10');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(wb, `${moment(today).format('DD-MM-YYYY')}-Sales.xlsx`);
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    // Filter - return selected table fields
    ...mapState(['filterDatas']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
